import { CallableInput } from "Components/Shared";
import AccountSelect from "Components/Shared/AccountSelect";
import ChargeUnitSelect from "Components/Shared/ChargeUnitSelect";
import DatePicker from "Components/Shared/DatePicker";
import { Field, Formik } from "formik";
import useCheckRole from "Hooks/APICheckRole";
import { useOrgCharge } from "Hooks/Endpoints";
import { APIOrganisationChargeProps } from "Providers/types";
import React from "react";
import {
  Button,
  Container,
  Form,
  Icon,
  Menu,
  Pagination,
  Segment,
  Table,
} from "semantic-ui-react";

const OrganisationServiceCharges = () => {
  const { hasRole, roles } = useCheckRole();
  const {
    charges,
    search,
    filter,
    remove,
    organisation,
    downloadServices,
    downloadProducts,
    downloadRates,
    downloadCDRs,
  }: APIOrganisationChargeProps = useOrgCharge();

  // const getTotalCharges = () => {
  //   return 0;
  // };
  return (
    <Container fluid>
      <Formik
        validateOnChange={false}
        enableReinitialize={true}
        initialValues={filter}
        onSubmit={(values, actions) => {
          search(values);
        }}
      >
        {({ handleSubmit, errors }) => (
          <Form onSubmit={handleSubmit} size='mini'>
            <Form.Group widths='equal'>
              <AccountSelect
                inline
                accounts={organisation?.customers}
                name='account'
                label='Account'
              />

              <ChargeUnitSelect name='unit' label='Unit Type' />

              <Field
                inline
                name='reference'
                label='Reference'
                component={CallableInput}
              />
              <Field
                inline
                name='ticketID'
                label='TicketID'
                component={CallableInput}
              />

              <DatePicker name='date' label='Date' />

              <Form.Field>
                <Button
                  primary
                  type='submit'
                  size='mini'
                  style={{ marginTop: "24px" }}
                >
                  Filter
                </Button>

                {hasRole("admin") && (
                  <Button
                    secondary
                    type='button'
                    size='mini'
                    onClick={() => downloadCDRs()}
                    style={{ marginTop: "24px" }}
                  >
                    CDRs
                  </Button>
                )}
              </Form.Field>
            </Form.Group>
          </Form>
        )}
      </Formik>
      <Menu size='mini'>
        <Menu.Item>
          <Button
            icon
            secondary
            type='button'
            size='mini'
            onClick={() => downloadServices()}
          >
            <Icon name='save' /> Download (Filtered) Charges
          </Button>
        </Menu.Item>
        <Menu.Item>
          <Button
            icon
            color='purple'
            type='button'
            size='mini'
            onClick={() => downloadProducts()}
          >
            <Icon name='save' /> Download Products
          </Button>
        </Menu.Item>
        <Menu.Item>
          <Button
            icon
            color='green'
            type='button'
            size='mini'
            onClick={() => downloadRates()}
          >
            <Icon name='save' /> Download Rates
          </Button>
        </Menu.Item>
      </Menu>
      {charges && (
        <Table stackable basic striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Reference</Table.HeaderCell>
              <Table.HeaderCell>Ticket ID</Table.HeaderCell>
              <Table.HeaderCell>Customer</Table.HeaderCell>
              <Table.HeaderCell>Description</Table.HeaderCell>
              <Table.HeaderCell>Category</Table.HeaderCell>
              <Table.HeaderCell>Start</Table.HeaderCell>
              <Table.HeaderCell>End</Table.HeaderCell>
              <Table.HeaderCell>Price</Table.HeaderCell>
              <Table.HeaderCell>Qty</Table.HeaderCell>
              <Table.HeaderCell>Total</Table.HeaderCell>
              <Table.HeaderCell>Unit</Table.HeaderCell>
              {hasRole("admin") && <Table.HeaderCell>Actions</Table.HeaderCell>}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {charges.content.map((c) => (
              <Table.Row key={c.id}>
                <Table.Cell>{c.reference}</Table.Cell>
                <Table.Cell>{c.ticketReference}</Table.Cell>
                <Table.Cell>{c.customer.name}</Table.Cell>
                <Table.Cell>{c.description}</Table.Cell>
                <Table.Cell>{c.type}</Table.Cell>
                <Table.Cell>{c.start}</Table.Cell>
                <Table.Cell>{c.end}</Table.Cell>
                <Table.Cell>{c.price}</Table.Cell>
                <Table.Cell>{c.qty}</Table.Cell>
                <Table.Cell>{c.total}</Table.Cell>
                <Table.Cell>{c.unit}</Table.Cell>
                {hasRole("admin") && (
                  <Table.Cell>
                    <Button color='red' onClick={() => remove(c.id)}>
                      Delete
                    </Button>
                  </Table.Cell>
                )}
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
      {charges && (
        <Pagination
          onPageChange={(event, data) => {
            if (data.activePage) {
              var page: number = +data.activePage;
              search({ ...filter, page: page - 1 });
            }
          }}
          defaultActivePage={charges.number + 1}
          totalPages={charges.totalPages}
        />
      )}
    </Container>
  );
};

export default OrganisationServiceCharges;
